module.exports = __webpack_public_path__ + "assets/img/travel-day33.dcb33739.png";